import React from 'react';
import { useCurator } from '@noths/curator-web';
import dynamic from 'next/dynamic';

import { isProd } from 'src/environment';
import type { ContentPageProps } from 'src/types/PageProps';

const Curator = dynamic(
  () =>
    import('@noths/curator-web').then(async (m) => {
      const urls = m.CURATOR_URLS;
      if (urls) {
        const baseUrl = isProd() ? urls.BASE_URL_PROD : urls.BASE_URL_QA;
        const streamUrl = isProd() ? urls.STREAM_URL_PROD : urls.STREAM_URL_QA;
        m.configureCurator({
          baseUrl,
          streamUrl,
        });
      }
      return m.Curator;
    }),
  { ssr: false },
);

interface CuratorWrapperProps {
  siteChromeContent?: ContentPageProps['siteChromeContent'];
}

export const CuratorWrapper = ({ siteChromeContent }: CuratorWrapperProps) => {
  const showCurator = siteChromeContent?.enableCurator ?? false;
  const { handleToggle, isCuratorOpen, redirectToPDP } = useCurator();

  if (!showCurator) {
    return null;
  }

  return <Curator isOpen={isCuratorOpen} onProductClick={redirectToPDP} onToggle={handleToggle} />;
};
